import { render } from "./CorpDir.vue?vue&type=template&id=54ac5d37&scoped=true"
import script from "./CorpDir.vue?vue&type=script&lang=js"
export * from "./CorpDir.vue?vue&type=script&lang=js"

import "./CorpDir.vue?vue&type=style&index=0&id=54ac5d37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ac5d37"]])

export default __exports__